import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";

export function generateRedirectGuard(redirectTo: string): CanActivateFn {
  return (route, state) => {
    const router = inject(Router);
    const fullPath = route.url
      .map((segment) => segment.path)
      .slice(1)
      .join("/"); // Preserve full path
    return router.createUrlTree([`/${redirectTo}/${fullPath}`]);
  };
}
